// extracted by mini-css-extract-plugin
module.exports = {"root":"body-text_root__2yfxU","sizemd":"body-text_sizemd__1G72f","sizelg":"body-text_sizelg__fP8Pe"};